import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Link } from 'react-router-dom';
import { BounceLoader } from 'react-spinners';
import DownloadPanel from './DownloadPanel';
import useSearch from '../../hooks/useSearch';

const ResultsTable = () => {
  const {
    articleSearch,
    criteria,
    results: {
      resultSet: {
        data: resultSet = [],
        total: totalResults = 0,
      } = {},
    },
    isLoading,
  } = useSearch();

  const renderArticleLinks = (value, tableMeta) => {
    const [id] = tableMeta.rowData;
    return (
      <Link to={`/article/${id}/`} className="article-link">
        {value}
      </Link>
    );
  };

  const columns = [
    {
      name: 'article_id',
      label: 'Article ID',
      options: {
        filter: false,
        sort: true,
        customBodyRender: renderArticleLinks,
      },
    },
    {
      name: 'title',
      label: 'Title',
      options: {
        filter: false,
        sort: true,
        customBodyRender: renderArticleLinks,

      },
    },
    {
      name: 'source',
      label: 'Source',
      options: {
        filter: true,
        sort: true,
        customBodyRender: renderArticleLinks,
      },
    },
    {
      name: 'published',
      label: 'Date/Time Published',
      options: {
        filter: false,
        sort: true,
        customBodyRender: renderArticleLinks,
      },
    },
  ];

  const customToolbar = () => <DownloadPanel />;

  const { page = 0, limit = 15 } = criteria;

  const tableOptions = {
    selectableRows: 'none',
    responsive: 'simple',
    // resizableColumns: true,
    print: false,
    filter: false,
    search: false,
    download: false,
    customToolbar,
    viewColumns: false,
    jumpToPage: true,
    serverSide: true,
    count: totalResults,
    page,
    rowsPerPage: limit,
    rowsPerPageOptions: [15, 25, 50, 100],
    onChangePage: (currentPage) => {
      articleSearch({ ...criteria, page: currentPage });
    },
    onChangeRowsPerPage: (numberOfRows) => {
      articleSearch({
        ...criteria,
        page: 0,
        limit: numberOfRows,
      });
    },
    onColumnSortChange: (changedColumn, direction) => {
      articleSearch({
        ...criteria,
        page: 0,
        sortBy: changedColumn,
        sortDirection: direction,
      });
    },
  };

  return (
    <div className="table-container">
      { isLoading && (
        <div className="search-loader">
          <BounceLoader
            color="#2b69b3"
          />
          <p>Please hold tight! Some detailed searches may take 1-2 minutes or more.</p>
        </div>
      )}
      <MUIDataTable
        className={`results-table${isLoading ? ' is-loading' : ''}`}
        title={`${totalResults.toLocaleString()} results`}
        data={resultSet}
        columns={columns}
        options={tableOptions}
      />
    </div>

  );
};

export default ResultsTable;
